import { createRouter, createWebHistory } from "vue-router";
import {
  ShopPage,
  ShopHomePage,
  ShopCheckoutPage,
  ShopCheckoutStatusPage,
  ShopCheckoutPaymentStatusPage,
  ShopPaymentCallbackPage,
  ShopOrderStatusPage,
  ShopMenuPage,
  ShopReservePage,
  HomePage,
  ReceiptPage,
  SignupPage,
  CollectedPage,
  ShopGroupOrderPage,
  RestaurantProfilePage,
  AccountProfilePage,
  MenuCreatorPage,
  AllRestaurantsPage,
  AllEventsPage,
  ProfilePage,
  GiftCardPage,
  WalletPassesPage,
  WalletPassInstallPage,
} from "@app/vue/pages/index";
import {
  ShopUserProfilePage,
  ShopUserAddressesPage,
  ShopUserOrdersPage,
  ShopUserLoyaltyPage,
  ShopUserSettingsPage,
} from "@app/vue/pages/ShopUser/subpages/index";
import {
  BookReservations,
  MenuPage,
  EventsPage,
  EventDetailsPage,
  ReservationRequestStatusPage,
  OrderPage,
} from "@app/vue/pages/ShopReserve/subpages/index";
import { ShopCheckoutResultPage } from "../pages/ShopCheckoutResult";

const routes = [
  {
    path: "/",
    alias: "",
    component: HomePage,
  },
  {
    path: "/account",
    component: AccountProfilePage,
    children: [
      {
        path: "profile",
        alias: "",
        component: ShopUserProfilePage,
      },
      {
        path: "addresses",
        component: ShopUserAddressesPage,
      },
      {
        path: "orders",
        component: ShopUserOrdersPage,
      },

      {
        path: "loyalty",
        component: ShopUserLoyaltyPage,
      },
      {
        path: "settings",
        component: ShopUserSettingsPage,
      },
    ],
  },
  {
    path: "/create-menu",
    component: MenuCreatorPage,
  },
  {
    path: "/restaurants/:city",
    component: AllRestaurantsPage,
  },
  {
    path: "/events/:city",
    component: AllEventsPage,
  },
  {
    path: "/profile/:id",
    component: RestaurantProfilePage,
  },
  {
    path: "/payments/:paymentGuid",
    component: ReceiptPage,
  },
  {
    // The claim funnel. Reached from a receipt QR with ?payment=<guid>.
    path: "/signup",
    component: SignupPage,
  },
  {
    path: "/collected",
    component: CollectedPage,
  },
  {
    path: "/wallet",
    component: WalletPassesPage,
  },
  {
    // Add one pass to Apple/Google Wallet; linked from the wallet emails.
    path: "/wallet/:serial",
    component: WalletPassInstallPage,
  },
  {
    path: "/gift_cards/:code",
    component: GiftCardPage,
  },
  {
    path: "/restaurant/:shopslug",
    component: ShopPage,
    children: [
      {
        path: "checkout/:checkoutId/payment-status",
        component: ShopCheckoutPaymentStatusPage,
      },
      {
        path: "",
        alias: "home",
        component: ShopHomePage,
      },
      {
        path: "group-order/:groupSlug",
        component: ShopGroupOrderPage,
        children: [
          { path: "", alias: "menu", component: ShopMenuPage },
          {
            path: "checkout",
            component: ShopCheckoutPage,
          },
          {
            path: "checkout-status/:checkoutId",
            component: ShopCheckoutStatusPage,
          },
          {
            path: "checkout-result/:checkoutId",
            component: ShopCheckoutResultPage,
          },
          {
            path: "checkout/:checkoutId/payment-status",
            redirect: (to: any) =>
              `/restaurant/${to.params.shopslug}/checkout/${to.params.checkoutId}/payment-status`,
          },
          {
            path: "payment-callback/checkout/:checkoutId/payment/:paymentGuid",
            component: ShopPaymentCallbackPage,
          },
        ],
      },
      {
        path: "order-status/:workflowId",
        component: ShopOrderStatusPage,
      },
      {
        path: "account",
        component: AccountProfilePage,
        children: [
          {
            path: "profile",
            alias: "",
            component: ShopUserProfilePage,
          },
          {
            path: "addresses",
            component: ShopUserAddressesPage,
          },
          {
            path: "orders",
            component: ShopUserOrdersPage,
          },

          {
            path: "loyalty",
            component: ShopUserLoyaltyPage,
          },
          {
            path: "settings",
            component: ShopUserSettingsPage,
          },
        ],
      },
      {
        path: "reserve",
        component: ShopReservePage,
        children: [
          {
            path: "",
            alias: "tables",
            component: BookReservations,
          },
          {
            path: "menu",
            component: MenuPage,
          },
          {
            path: "order",
            component: OrderPage,
          },
          {
            path: "events",
            component: EventsPage,
          },
          {
            path: "events/:eventId",
            component: EventDetailsPage,
          },
          {
            path: "reservation-request/:requestId",
            component: ReservationRequestStatusPage,
          },
          {
            path: "checkout/:checkoutId/payment-status",
            redirect: (to: any) =>
              `/restaurant/${to.params.shopslug}/checkout/${to.params.checkoutId}/payment-status`,
          },
        ],
      },
    ],
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from) {
    const withinAccount = (route: typeof to) =>
      route.matched.some((r) => r.components?.default === AccountProfilePage);
    // Switching account tabs keeps the header in place: only scroll back up
    // far enough for the tab bar to sit at its sticky position.
    if (withinAccount(to) && withinAccount(from)) {
      const anchor = document.querySelector("[data-account-tabs-anchor]");
      if (!anchor) return false;
      const anchorTop = anchor.getBoundingClientRect().top + window.scrollY;
      return window.scrollY > anchorTop ? { top: anchorTop } : false;
    }
    return { top: 0 };
  },
});
